<template>
  <div class="customer-invite-create">
    <b-container>
      <CustomerInviteForm
        @invite-sent="handleInviteSent"
        @invite-error="handleInviteError"
      />
    </b-container>
  </div>
</template>

<script>
import CustomerInviteForm from '@/components/CustomerInviteForm.vue'

export default {
  name: 'CustomerInviteCreate',
  components: {
    CustomerInviteForm
  },
  methods: {
    handleInviteSent(success) {
      if (success) {
        this.$bvToast.toast('Customer invitation sent successfully', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
        this.$router.push('/admin/customer-invites');
      }
    },
    handleInviteError(error) {
      this.$bvToast.toast('Error sending customer invite: ' + error, {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
    }
  }
}
</script>

<style scoped>
.customer-invite-create {
  padding: 20px;
}
</style>
